<template>
  <asc-dialog
    :text="plotTitle"
    :show-dialog="showDialog"
    :on-close="handleClose"
    :on-primary="handleAccept"
    :width="900"
    primary-button-text="Edit"
  >
    <template v-if="showDialog">
      <asc-plot-preview
        :loading="loading"
        :image-source="imageSource"
      ></asc-plot-preview>
    </template>
  </asc-dialog>
</template>

<script>
import { AscDialogMixin, AscPlotPreviewMixin } from '@/components/mixins'
import AscDialog from '@/components/atoms/AscDialog'
import AscPlotPreview from './AscPlotPreview'

export default {
  name: 'AscPlotPreviewDialog',

  components: {
    AscDialog,
    AscPlotPreview,
  },

  mixins: [AscDialogMixin, AscPlotPreviewMixin],

  methods: {
    handleAccept() {
      this.onAccept()
      this.handleClose()
    },
  },
}
</script>
